import { gql } from '@apollo/client';

export const sellerFragment = gql`
  fragment sellerInfo on Trader {
    id
    firstName
    middleName
    lastName
    phone
    entityName
    callingCode {
      id
      callingCode
    }
    addresses {
      id
      city {
        id
        cityName
      }
      state {
        id
        stateName
      }
      country {
        id
        country
      }
      houseNumber
      street
      pinCode
      area
    }
  }
`;

export const gradesFragment = gql`
  fragment gradesInfo on Grade {
    id
    name
    productSubCategoryManufacturer
    category {
      id
      name
    }
  }
`;

export const rateUnitFragment = gql`
  fragment rateUnitInfo on CountryCurrency {
    id
    currencyName
    countryCode
    isoCurrencyCode
    callingCode
  }
`;

export const TRADER_BASIC_INFORMATION_FRAGMENT = `
  fragment TraderBasicInformation on Trader {
    entityName
    tradeName
    tradeGstIn
    tdsEligible
    legalName
    gstInStatus
    accumulatedOrderAmount
    id
  }
`;
export const TRADER_CONTACT_INFORMATION_FRAGMENT = `
  fragment TraderContactInformation on Trader {
    firstName
    middleName
    lastName
    phone
    email
    addresses {
      // Include Address fields here
    }
  }
`;
export const TRADER_ADDITIONAL_DETAILS_FRAGMENT = `
  fragment TraderAdditionalDetails on Trader {
    language
    profile
    deviceId
    fcmToken
    status
    kycStatus
    roles {
      // Include Role fields here
    }
    permissions {
      // Include Permission fields here
    }
    kyc {
      // Include UserKYC fields here
    }
    userSetting {
      // Include UserSetting fields here
    }
    isKycVerified
    createdAt
    callingCode {
      // Include CountryCurrency fields here
    }
    isGstVerified
  }
`;
